import * as THREE from "three";
import { SETTINGS } from "../SETTINGS";

export const createScene = () => {
  const scene = new THREE.Scene();
  // scene.background = null;
  return scene;
};

export const createRenderer = (canvas: HTMLCanvasElement) => {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    alpha: true,
    antialias: true,
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0x000000, 0); // 透明に設定
  return renderer;
};

export const createCamera = (aspect: number) => {
  const camera = new THREE.PerspectiveCamera(
    SETTINGS.camera.fov,
    aspect,
    SETTINGS.camera.near,
    SETTINGS.camera.far
  );
  camera.position.set(
    SETTINGS.camera.position.x,
    SETTINGS.camera.position.y,
    SETTINGS.camera.position.z
  );
  camera.lookAt(SETTINGS.camera.lookAt.x, SETTINGS.camera.lookAt.y, SETTINGS.camera.lookAt.z);
  return camera;
};
